import {factory} from '../shared/app-logging';

const logger = factory.getLogger('PollyVoice');

export class PollyVoice {
  constructor(
    public id: string,
    public gender: string,
    public languageCode: string,
    public languageName: string,
    public name: string
  ) {
  }

}
